import { render, staticRenderFns } from "./SidebarSubNavCustom.vue?vue&type=template&id=4053b684&scoped=true"
import script from "./SidebarSubNavCustom.vue?vue&type=script&lang=js"
export * from "./SidebarSubNavCustom.vue?vue&type=script&lang=js"
import style0 from "./SidebarSubNavCustom.vue?vue&type=style&index=0&id=4053b684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053b684",
  null
  
)

export default component.exports